export default __webpack_public_path__ + "static/media/undraw_youtube_tutorial_re_69qc.6dd2cc53.svg";